import { Observable } from 'rxjs/Rx' // production build won't find Observable.merge, just if imported from this path
import 'rxjs/add/observable/merge'
import { map } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { notifySendMouseEvent, mouseDown, mouseUp, mouseMove, mouseWheel } from '../actions/toolbar'

const mouseEvents = {
  MOUSE_UP: 0,
  MOUSE_DOWN: 1,
  MOUSE_MOVE: 2,
  MOUSE_WHEEL: 3
}

function scrollDirection (delta) {
  if (delta > 0) { return 1 }
  if (delta < 0) { return 2 }
  return 0
}

export function handleMouseEvents (action$) {
  const mousedown$ = action$.pipe(
    ofType(mouseDown),
    map((action) => action.payload),
    map((event) => ({
      payload: [mouseEvents.MOUSE_DOWN, event.offsetX, event.offsetY, event.button]
    })))

  const mouseup$ = action$.pipe(
    ofType(mouseUp),
    map((action) => action.payload),
    map((event) => ({
      payload: [mouseEvents.MOUSE_UP, event.offsetX, event.offsetY, event.button]
    })))

  const mousemove$ = action$.pipe(
    ofType(mouseMove),
    map((action) => action.payload),
    map((event) => ({
      payload: [mouseEvents.MOUSE_MOVE, event.offsetX, event.offsetY, event.button]
    })))

  const mousewheel$ = action$.pipe(
    ofType(mouseWheel),
    map((action) => action.payload),
    map((event) => ({
      scrollDirectionX: scrollDirection(event.deltaX),
      scrollDirectionY: scrollDirection(event.deltaY)
    })),
    map((event) => ({
      payload: [mouseEvents.MOUSE_WHEEL, event.scrollDirectionX, event.scrollDirectionY, 0]
    })))

  const mouse$ = Observable.merge(
    // modifierActiveDown$,
    mouseup$,
    mousedown$,
    mousemove$,
    mousewheel$,
    // modifierActiveUp$
  ).pipe(
    map((event) => Uint16Array.from(event.payload)),
    map((databuffer) => notifySendMouseEvent(databuffer)))

  return mouse$
}
